/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateDraft.defs.js'
export * as $defs from './updateDraft.defs.js'
